import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import claritySDK from '@microsoft/clarity';

import type { TrackingProvider } from '../interfaces/tracking-provider.interface';
import type { TrackingEvent } from '../interfaces/tracking-event.interface';
import { TRACKING_CONFIG } from '../tracking.tokens';

@Injectable()
export class ClarityTrackingProvider implements TrackingProvider {
  public readonly name = 'clarity';

  private readonly platformId = inject(PLATFORM_ID);
  private readonly config = inject(TRACKING_CONFIG);
  private readonly esBrowser = isPlatformBrowser(this.platformId);

  private initialized = false;

  public initialize(): void {
    if (!this.esBrowser) return;
    if (!this.config.clarity.habilitado) {
      console.log('[ClarityProvider] deshabilitado en este ambiente');
      return;
    }
    if (this.initialized) return;
    this.initialized = true;
    claritySDK.init(this.config.clarity.projectId);
  }

  public isAvailable(): boolean {
    return this.esBrowser && this.config.clarity.habilitado && this.initialized;
  }

  public track(event: TrackingEvent): void {
    if (!this.isAvailable()) return;

    claritySDK.event(event.name);

    if (event.category) claritySDK.setTag('category', event.category);
    if (event.action) claritySDK.setTag('action', event.action);
    if (event.flow) claritySDK.setTag('flow', event.flow);
    if (event.section) claritySDK.setTag('section', event.section);
    if (event.label) claritySDK.setTag('label', event.label);
    if (event.state) claritySDK.setTag('state', event.state);

    if (event.metadata) {
      for (const [key, val] of Object.entries(event.metadata)) {
        claritySDK.setTag(key, String(val));
      }
    }
  }

  public identificarSesion(sessionId: string): void {
    if (!this.isAvailable()) return;
    claritySDK.identify(sessionId);
  }
}
